<template>
   <div class="sunning-box">
          <van-nav-bar
  title="苏宁易购"
  fixed
  left-arrow
  @click-left="$router.go(-1)"
/>
    <div @click="$router.push('/sunning/search')">
        <vueSearch></vueSearch>
    </div>
     <!-- <van-tabs>
        <van-tab title="推荐">
      </van-tab>
     </van-tabs> -->
     <good v-for="(item,index) in goodList"
       :good="item"
      :key="index">
    </good>
     <van-button type="default" size="large" v-show="more" @click="loadMore">加载更多</van-button>
   </div>
</template>

<script>
  import good from '@/components/sunning/good'
export default {
    components:{
        good
    },
   data(){
      return {
        goodList:[],
        more: true,
        page: 1,
      }
   },
   created(){
     this.getData();
   },
   methods:{
       // 获取数据
    getData() {
      this.Post({
        page:this.page
      }, "/sunning/inverstmentcommodity", res => {
        if (res.states == 1) {
          let good = res.data.sn_responseContent.sn_body.queryInverstmentcommodity || [];
          if(good.length === 0){
            this.more = false
          }
          this.goodList = this.goodList.concat(good);
        }
      });
    },
     // 加载更多
    loadMore() {
      if (this.more) {
        this.page++;
        this.getData();
      }
    },
   }
}
</script>

<style lang="less" scoped>
.sunning-box{
   padding-top: 46px;
}
</style>


// WEBPACK FOOTER //
// src/pages/sunning/index.vue